export default "__VITE_ASSET__3ed8880e__"